var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgEntitiesIcon = function (props) { return (_jsx("svg", __assign({ width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M27.167 8H16.5l-2.667-2.667h-8A2.663 2.663 0 0 0 3.18 8l-.013 16c0 1.467 1.2 2.667 2.666 2.667h22.36c.907 0 1.64-.747 1.64-1.64v-14.36C29.833 9.2 28.633 8 27.167 8Zm0 16H5.833V8h6.894l2.666 2.667h11.774V24ZM24.5 16h-16v-2.667h16V16Zm-5.333 5.333H8.5v-2.666h10.667v2.666Z", fill: "#fff" }) }))); };
var Memo = memo(SvgEntitiesIcon);
export default Memo;
//# sourceMappingURL=EntitiesIcon.js.map